/* CTR B2 — "How Jupi works" simple inline video player.
   Click the play button to reveal/play a native video or embed. */
(function () {
  function activate(media) {
    var type = media.getAttribute('data-video-type');
    var poster = media.querySelector('.ctr-b2-hjw__poster');
    var play = media.querySelector('.ctr-b2-hjw__play');

    if (type === 'native') {
      var wrap = media.querySelector('.ctr-b2-hjw__video');
      if (!wrap) return;
      wrap.hidden = false;
      var v = wrap.querySelector('video');
      if (v) {
        v.removeAttribute('controls');
        v.loop = true;
        v.setAttribute('loop', 'loop');
        v.play().catch(function () {});
      }
    } else if (type === 'embed') {
      var src = media.getAttribute('data-embed');
      if (!src) return;
      var wrap2 = media.querySelector('.ctr-b2-hjw__video');
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      wrap2.innerHTML = '<iframe src="' + src + sep + 'autoplay=1&rel=0&controls=0&loop=1&playsinline=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
      wrap2.hidden = false;
    } else {
      return; // no video configured
    }
    if (poster) poster.style.display = 'none';
    if (play) play.hidden = true;
  }

  function init(root) {
    (root || document).querySelectorAll('.ctr-b2-hjw__media[data-video-type]').forEach(function (media) {
      if (media.getAttribute('data-video-type') === 'none') return;
      var play = media.querySelector('.ctr-b2-hjw__play');
      if (!play) return;
      play.addEventListener('click', function () { activate(media); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
